export default __webpack_public_path__ + "static/media/cupones.40cb24c7.svg";